/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOnboardingConfig} from '../api'

 export const useQueryGetOnboardingConfig = createReactQueryHook('getOnboardingConfig', getOnboardingConfig)
